export const colors = {

    BACKGROUND: '#F5F5F5',

    PRIMARY_900: '#263C7B',
    PRIMARY_LIGHT: 'rgba(226, 7, 47, .3)',
    PRIMARY_500: '#3366ff',
    PRIMARY_400: '#598bff',


    SECONDARY_900: '#EFA930',
    SECONDARY_LIGHT: 'rgba(247, 177, 47, .3)',
    SECONDARY_500: '#EE741A',
    SECONDARY_400: '#E85623',

    SUCCESS_900: '#588440',
    SUCCESS_50: '#F7FFF9',

    ALERT_900: '#283474',
    ALERT_50: '#F3EFE5',

    CARD: '#E8ECF1',
    CARDSELECTED: '#E5F3C8',
    SHAPE: '#DCDCDC',
    GRAY: '#C4C4C4',
    TITLE: '#FFF',
    TEXT: '#6F6F6F',
    TEXT_LIGHT: '#999999',

    CARD_SS_DISTRIBUTED: '#263C7B',
    CARD_SS_OPEN: '#588440',
    CARD_SS_CLOSED: '#E2062E',

    MAP_FILL: 'rgba(232, 236, 241, .5)',
    MAP_STROKER:'#6F6F6F',

    GRADIENT: [ '#EE741A' ,'#FFE242'],
    GRADIENT2: [ '#7C0117' ,'#E2072F'],
};

export const  FONTS = {

    TITLE: 'Roboto_700Bold',
    DESTAK: 'Roboto_500Medium',
    TEXT: 'Roboto_400Regular',
  
};